module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.8f996f8b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CircularStd-Black.woff2
// module id = 214
// module chunks = 0